// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 47"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M36.6 20c5.3 0 9.6-4.3 9.6-9.6S41.9.8 36.6.8 27 5.1 27 10.4c0 1.8.5 3.4 1.3 4.8l-14 8.8c-1.4-1.2-3.3-1.9-5.3-1.9-4.6 0-8.3 3.7-8.3 8.3s3.7 8.3 8.3 8.3c2.9 0 5.4-1.5 6.9-3.7l11.7 4.7c.1 3.7 3.2 6.6 6.9 6.6 3.8 0 6.9-3.1 6.9-6.9s-3.1-6.9-6.9-6.9c-2.9 0-5.4 1.8-6.4 4.4L17 32.4c.2-.6.3-1.3.3-2 0-1.5-.4-3-1.2-4.2l13.8-8.8C31.7 19 34 20 36.6 20zm-2.1 15.2c2.3 0 4.1 1.9 4.1 4.1s-1.9 4.1-4.1 4.1-4.1-1.9-4.1-4.1 1.8-4.1 4.1-4.1zm2.1-31.7c3.8 0 6.9 3.1 6.9 6.9s-3.1 6.9-6.9 6.9c-3.8 0-6.9-3.1-6.9-6.9s3.1-6.9 6.9-6.9zM9 35.9c-3 0-5.5-2.5-5.5-5.5S6 24.8 9 24.8s5.5 2.5 5.5 5.5S12 35.9 9 35.9z"/></svg>;
};

export default React.memo(Share);
